import React from 'react';
import Grid from '@mui/material/Grid';
import PageLayout from '../../components/common/page-layout';
import InvoicesTable from '../../components/inventory/invoices-table';
import { Typography } from '@mui/material';

export default function Delivery() {
  return (
    <PageLayout pageTitle="فاکتور">
      <Grid container spacing={3} justifyContent="center">
        <Grid item xs={12} lg={9}>
          <Typography variant="h6" sx={{ pb: 2 }}>
            صف تحویل سفارش‌ها
          </Typography>
          <InvoicesTable />
        </Grid>
      </Grid>
    </PageLayout>
  );
}
